module.exports = __webpack_public_path__ + "img/icon-empresa.498fea7a.svg";